import MODULE_ID from './moduleId';
import routeHandler from './routes';

const module = {
  moduleType: 'Unfalldesk',
  moduleId: MODULE_ID,
  api: 'unfalldesk',

  routeHandler,
};

export default module;
